var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 16.5,
    r: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3a9 9 0 100 18 9 9 0 000-18zm0 16.5a7.5 7.5 0 110-15 7.5 7.5 0 010 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.1a3 3 0 00-3 3v.8h1.5V10a1.5 1.5 0 111.5 1.5h-.8V15h1.6v-2a3 3 0 00-.8-5.9z"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgZmlsbD0iY3VycmVudENvbG9yIj48Y2lyY2xlIGN4PSIxMiIgY3k9IjE2LjUiIHI9Ii45Ii8+PHBhdGggZD0iTTEyIDNhOSA5IDAgMTAwIDE4IDkgOSAwIDAwMC0xOHptMCAxNi41YTcuNSA3LjUgMCAxMTAtMTUgNy41IDcuNSAwIDAxMCAxNXoiLz48cGF0aCBkPSJNMTIgNy4xYTMgMyAwIDAwLTMgM3YuOGgxLjVWMTBhMS41IDEuNSAwIDExMS41IDEuNWgtLjhWMTVoMS42di0yYTMgMyAwIDAwLS44LTUuOXoiLz48L2c+PC9zdmc+";
export { SvgIconQuestion as ReactComponent };